<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img
        id="profile-img"
        src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
        class="profile-img-card"
      />
      <form name="form" @submit.prevent="handleRegister">
        <div class="columns">
          <div class="form-group column is-full">
            <label for="username">Username</label>
            <input
              v-model="user.username"
              v-validate="'required|min:3|max:20'"
              type="text"
              class="form-control"
              name="username"
            />
            <div
              v-if="submitted && errors.has('username')"
              class="alert-danger"
            >
              {{ errors.first('username') }}
            </div>
          </div>
          <div class="form-group column is-full">
            <label for="email">Email</label>
            <input
              v-model="user.email"
              v-validate="'required|email|max:50'"
              type="email"
              class="form-control"
              name="email"
            />
            <div v-if="submitted && errors.has('email')" class="alert-danger">
              {{ errors.first('email') }}
            </div>
          </div>
          <div class="form-group column is-full">
            <label for="password">Password</label>
            <input
              v-model="user.password"
              v-validate="'required|min:8|max:40'"
              type="password"
              class="form-control"
              name="password"
            />
            <div
              v-if="submitted && errors.has('password')"
              class="alert-danger"
            >
              {{ errors.first('password') }}
            </div>
          </div>

          <b-field class="form-group column is-full" label="Select a role">
            <b-select placeholder="Select a role" v-model="user.role">
              <option
                v-for="option in roles"
                :value="option.id"
                :key="option.id"
              >
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field label="Team">
            <multiselect
              v-model="user.team"
              :options="availableTeams"
              track-by="id"
              label="value"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="true"
              :preserve-search="true"
              placeholder="Choose a team for the new user"
              :preselect-first="false"
            >
            </multiselect>
          </b-field>

          <div class="form-group column is-full">
            <b-button
              @click="handleRegister"
              type="is-success"
              class="submit-user"
            >
              Create user
            </b-button>
            <!-- <button class="btn btn-primary btn-block">Create user</button> -->
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import User from '../../models/user';
import UtilService from '../../services/util';
import TeamService from '../../services/team.service';
import Multiselect from 'vue-multiselect';

export default {
  name: 'Register',
  components: {
    Multiselect,
  },
  data() {
    return {
      user: new User('', '', '', '', ''),
      submitted: false,
      selectedTeam: null,
      roles: [
        { id: 1, name: 'user' },
        { id: 2, name: 'moderator' },
      ],
      availableTeams: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    isAdmin() {
      return UtilService.isAdmin();
    },
  },
  async mounted() {
    if (this.isAdmin) {
      this.roles.push({ id: 3, name: 'admin' });
    }
    await TeamService.getTeams().then((response) => {
      this.availableTeams = response.data.map((team) => ({
        value: team.name,
        ...team,
      }));
    });
  },
  methods: {
    handleRegister() {
      this.submitted = true;

      this.$validator.validate().then((isValid) => {
        if (isValid) {
          this.$store.dispatch('auth/register', this.user).then(
            () => {
              this.user = new User('', '', '', '', '');
              this.selectedTeam = null;
              this.$buefy.toast.open({
                duration: 3000,
                message: 'Added new agent',
                position: 'is-bottom',
                type: 'is-success',
              });
            },
            (error) => {
              const message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
              this.$buefy.toast.open({
                duration: 3000,
                message,
                position: 'is-bottom',
                type: 'is-danger',
              });
            }
          );
        }
      });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

button.submit-user {
  width: 100%;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>
